import React from "react";
import {validityPeriodToDisplay, valueOrEmDash} from "../../common/displayUtils";
import moment from "moment";

const FAILURE_MESSAGE = "Last differing recommendation could not be loaded";

const LastDifferingRecommendation = (props) => {
    let content;
    if (props.lastDifferingRecommendation === null) {
        content = <div className="x-last-differing-recommendation"><em><small>Loading...</small></em></div>;
    } else {
        let messages;
        if (props.lastDifferingRecommendation.errors.length > 0) {
            messages = [ FAILURE_MESSAGE ].concat(props.lastDifferingRecommendation.errors);
        } else if (props.lastDifferingRecommendation.success === null) {
            messages = [ "None" ];
        } else {
            let last = props.lastDifferingRecommendation.success;
            let validityPeriod = last.time_horizon === null ? null : last.time_horizon.replace("TIME_HORIZON_", "VALIDITY_PERIOD_");
            messages = [ last.direction,
                         last.derivative_description,
                         "Dissemination date: " + moment(last.disseminated_on).format("MMM D, YYYY h:mma"),
                         "Target price: " + valueOrEmDash(last.target_price),
                         "Validity period: " + valueOrEmDash(validityPeriodToDisplay(validityPeriod)) ];
        }
        content = messages.map((line, idx) =>
            <div key={idx} className="x-last-differing-recommendation"><small>{line}</small></div>
        );
    }

    return (
        <div>
            <h5>Last Differing Recommendation</h5>
            { content }
        </div>
    );
};

export default LastDifferingRecommendation;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/LastDifferingRecommendation.js
 **/